export default __webpack_public_path__ + "static/media/EH.bff13c99.svg";